export var EDataPointType;
(function (EDataPointType) {
    EDataPointType["SignificantVLR"] = "significantVLR";
    EDataPointType["SignificantGLR"] = "significantGLR";
    EDataPointType["NotSignificantVLR"] = "notSignificantVLR";
    EDataPointType["NotSignificantGLR"] = "notSignificantGLR";
})(EDataPointType || (EDataPointType = {}));
